var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('el-button',{attrs:{"type":"primary"}},[_vm._v("手机端首页")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }